module.exports = __webpack_public_path__ + "img/hachiouji.64810ac4.jpg";